/* feitan-gallery v24 - clean layout + video lazy-load */
(function(){
  var mq=window.matchMedia('(max-width:749px)');
  var currentPath='';
  var building=false;

  /* === VIDEO LAZY-LOAD: save 3-4MB on mobile === */
  function lazyVideos(){
    if(!mq.matches)return;
    var videos=document.querySelectorAll('video[autoplay]');
    if(!videos.length)return;
    if(!('IntersectionObserver' in window))return;

    var vObs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting)return;
        var v=e.target;
        var stored=v.getAttribute('data-feitan-srcs');
        if(stored){
          try{
            var srcs=JSON.parse(stored);
            srcs.forEach(function(s){
              var src=document.createElement('source');
              src.src=s.src;
              if(s.type)src.type=s.type;
              v.appendChild(src);
            });
          }catch(ex){}
          v.removeAttribute('data-feitan-srcs');
          v.load();
          v.play().catch(function(){});
        }
        vObs.unobserve(v);
      });
    },{rootMargin:'200px'});

    videos.forEach(function(v){
      var rect=v.getBoundingClientRect();
      if(rect.top>window.innerHeight){
        var sources=v.querySelectorAll('source');
        var srcData=[];
        sources.forEach(function(s){
          srcData.push({src:s.src,type:s.type||''});
        });
        if(srcData.length){
          v.setAttribute('data-feitan-srcs',JSON.stringify(srcData));
          sources.forEach(function(s){s.remove();});
          v.removeAttribute('autoplay');
          v.preload='none';
          v.load();
          vObs.observe(v);
        }
      }
    });
  }

  function initLazyVideos(){
    setTimeout(lazyVideos,100);
    setTimeout(lazyVideos,800);
  }

  /* === GALLERY === */
  function extractImages(ss){
    var items=ss.querySelectorAll('sht-carousel-itm');
    var images=[];
    for(var i=0;i<items.length;i++){
      var img=items[i].querySelector('img');
      if(!img||!img.src)continue;
      var src=img.src.split('?')[0];
      if(!src||src.indexOf('/cdn/')< 0)continue;
      images.push({
        src:src,
        alt:img.alt||'',
        width:img.naturalWidth||img.width||800,
        height:img.naturalHeight||img.height||800
      });
    }
    return images;
  }

  function build(ss,images){
    var g=document.createElement('div');g.className='feitan-mg';
    var td=document.createElement('div');td.className='feitan-mg-thumbs';
    var slider=document.createElement('div');slider.className='feitan-mg-slider';
    var slides=[];

    images.forEach(function(m,i){
      var slide=document.createElement('div');slide.className='feitan-mg-slide';
      var img=document.createElement('img');
      img.src=m.src+'?width=1400';
      img.srcset=m.src+'?width=800 800w,'+m.src+'?width=1200 1200w,'+m.src+'?width=1600 1600w';
      img.sizes='(max-width:749px) 85vw, 800px';
      img.alt=m.alt;
      if(i===0){
        img.loading='eager';
        img.fetchPriority='high';
      }else{
        img.loading='lazy';
      }
      img.width=m.width;img.height=m.height;
      slide.appendChild(img);
      slide.addEventListener('click',function(){
        var btns=ss.querySelectorAll('.js-product-media-open-gallery-btn');
        if(btns[i])btns[i].click();
      });
      slider.appendChild(slide);
      slides.push(slide);
    });

    var thumbEls=[];
    images.forEach(function(m,i){
      var t=document.createElement('div');t.className='feitan-mg-t'+(i===0?' on':'');
      var ti=document.createElement('img');
      ti.src=m.src+'?width=200';
      ti.alt=m.alt;ti.loading='lazy';
      t.appendChild(ti);
      t.onclick=function(){
        slides[i].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
      };
      td.appendChild(t);
      thumbEls.push(t);
    });

    var scrollTimer;
    slider.addEventListener('scroll',function(){
      clearTimeout(scrollTimer);
      scrollTimer=setTimeout(function(){
        var sl=slider.scrollLeft;
        var sw=slides[0]?slides[0].offsetWidth:1;
        var idx=Math.round(sl/Math.max(sw,1));
        if(idx<0)idx=0;if(idx>=thumbEls.length)idx=thumbEls.length-1;
        thumbEls.forEach(function(t,i){
          if(i===idx)t.classList.add('on');else t.classList.remove('on');
        });
        thumbEls[idx].scrollIntoView({block:'nearest',behavior:'smooth'});
      },80);
    });

    function syncH(){
      var h=slider.offsetHeight;
      if(h>50)td.style.maxHeight=h+'px';
    }
    var firstImg=slides[0]?slides[0].querySelector('img'):null;
    if(firstImg)firstImg.onload=syncH;
    setTimeout(syncH,500);setTimeout(syncH,1500);

    g.appendChild(td);
    g.appendChild(slider);
    ss.parentNode.insertBefore(g,ss);
  }

  function go(){
    if(!mq.matches||building)return;
    var path=window.location.pathname;
    if(path.indexOf('/products/')<0)return;

    /* Skip camera de chasse - restore original gallery */
    if(path.indexOf('chasse')>=0){
      if(!document.getElementById('feitan-chasse-restore')){
        var s=document.createElement('style');
        s.id='feitan-chasse-restore';
        s.textContent='@media(max-width:749px){sht-prd-slideshow{position:static!important;width:auto!important;height:auto!important;overflow:visible!important;clip:auto!important;clip-path:none!important;opacity:1!important;pointer-events:auto!important;}}';
        document.head.appendChild(s);
      }
      var old=document.querySelector('.feitan-mg');
      if(old)old.remove();
      return;
    }

    if(path===currentPath&&document.querySelector('.feitan-mg'))return;

    var ss=document.querySelector('sht-prd-slideshow');
    if(!ss)return;

    var old=document.querySelector('.feitan-mg');
    if(old)old.remove();

    var images=extractImages(ss);
    if(images.length>0){
      currentPath=path;
      build(ss,images);
      initLazyVideos();
      return;
    }

    /* Fallback: fetch if DOM images not ready */
    var handle=path.split('/products/')[1].split('?')[0].split('#')[0];
    if(!handle)return;
    currentPath=path;
    building=true;

    fetch('/products/'+handle+'.js')
      .then(function(r){return r.json()})
      .then(function(p){
        building=false;
        if(document.querySelector('.feitan-mg'))return;
        if(window.location.pathname!==path){currentPath='';return;}
        if(!p||!p.media||!p.media.length)return;
        var imgs=p.media.filter(function(m){return m.media_type==='image'});
        if(!imgs.length)return;

        ss=document.querySelector('sht-prd-slideshow');
        if(!ss)return;

        var formatted=imgs.map(function(m){
          return {src:m.src.split('?')[0],alt:m.alt||p.title,width:m.width,height:m.height};
        });
        build(ss,formatted);
        initLazyVideos();
      })
      .catch(function(e){building=false;console.warn('feitan-gallery:',e)});
  }

  /* MutationObserver: detect new sht-prd-slideshow instantly */
  var domObserver=new MutationObserver(function(muts){
    if(!mq.matches)return;
    for(var i=0;i<muts.length;i++){
      var added=muts[i].addedNodes;
      for(var j=0;j<added.length;j++){
        var n=added[j];
        if(n.nodeType!==1)continue;
        if(n.tagName==='SHT-PRD-SLIDESHOW'||(n.querySelector&&n.querySelector('sht-prd-slideshow'))){
          currentPath='';
          setTimeout(go,0);
          setTimeout(go,150);
          setTimeout(go,400);
          return;
        }
      }
    }
  });
  domObserver.observe(document.documentElement,{childList:true,subtree:true});

  /* Viewport change */
  function cleanup(){var o=document.querySelector('.feitan-mg');if(o)o.remove();currentPath='';}
  mq.addEventListener('change',function(e){
    if(e.matches){setTimeout(go,0);setTimeout(go,300);}else{cleanup();}
  });

  /* Initial load */
  if(mq.matches){
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',function(){setTimeout(go,0);setTimeout(go,300);initLazyVideos();});
    }else{
      setTimeout(go,0);setTimeout(go,300);
      initLazyVideos();
    }
  }

  /* AJAX nav backup */
  window.addEventListener('popstate',function(){currentPath='';setTimeout(go,100);});
  var origPush=history.pushState;
  history.pushState=function(){origPush.apply(this,arguments);currentPath='';setTimeout(go,100);};
  var origReplace=history.replaceState;
  history.replaceState=function(){origReplace.apply(this,arguments);currentPath='';setTimeout(go,100);};
})();
